import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UploadFileComponent} from './components/upload-file/upload-file.component';
import {LoginComponent} from './components/auth/login/login.component';
import {MainComponent} from './components/main/main.component';
import {AuthGuard} from './_guards/auth.guard';
import {BrowseFilesComponent} from './components/browse-files/browse-files.component';
import {InterruptActionGuard} from './_guards/interrupt-action.guard';
import {MainWithoutBarComponent} from './components/main-without-bar/main-without-bar.component';
import {LoginByTokenComponent} from './components/auth/login-by-token/login-by-token.component';
import {InactiveComponent} from './components/auth/inactive/inactive.component';
import {WhiteCardComponent} from './components/main-without-bar/white-card/white-card.component';
import {ResetPasswordConfirmComponent} from './components/auth/reset-password-confirm/reset-password-confirm.component';
import {ResetPasswordComponent} from './components/auth/reset-password/reset-password.component';
import {FirstLoginComponent} from './components/auth/first-login/first-login.component';
import {AuthFirstLoginGuard} from './_guards/auth-first-login.guard';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {TransfersViewComponent} from './components/transfers-view/transfers-view.component';
import {DownloadShareFileViewComponent} from './components/download-share-file-view/download-share-file-view.component';
import {RequestsListViewComponent} from './components/requests-list-view/requests-list-view.component';
import {UploadRequestedFilesComponent} from './components/upload-requested-files/upload-requested-files.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: UploadFileComponent,
        canDeactivate: [InterruptActionGuard]
      },
      {
        path: 'browse',
        component: BrowseFilesComponent,
      },
      {
        path: 'transfers',
        component: TransfersViewComponent,
      },
      {
        path: 'requests',
        component: RequestsListViewComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      }
    ]
  }, {
  path: '',
  component: MainWithoutBarComponent,
  children: [
    {
      path: '',
      component: WhiteCardComponent,
      children: [
        {
          path: 'login',
          component: LoginComponent
        },
        {
          path: 'oauth2/confirm/:uidb/:token',
          component: LoginByTokenComponent,
        },
        {
          path: 'inactive',
          component: InactiveComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'first-login',
          component: FirstLoginComponent,
          canActivate: [AuthFirstLoginGuard],
        },
        {
          path: 'reset-password/confirm/:uidb/:token',
          component: ResetPasswordConfirmComponent,
        },
        {
          path: 'reset-password',
          component: ResetPasswordComponent,
        },
        {
          path: 'share-file/:token',
          component: DownloadShareFileViewComponent,
        },
        {
          path: 'upload-requested-file/:token',
          component: UploadRequestedFilesComponent,
        },
      ]
    }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
